import {
  UpdateReviewerStrategiesPerformanceReviewProcessDocument,
  UpdateReviewerStrategiesPerformanceReviewProcessMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'

export const useUpdateReviewProcessReviewerStrategies = () => {
  const [updateReviewreviewerStrategies, { loading }] = useMutation(
    UpdateReviewerStrategiesPerformanceReviewProcessDocument,
    {
      extractorFn: (data) =>
        data.performanceMutations.updateReviewerStrategiesPerformanceReviewProcess,
    }
  )

  const updateReviewerStrategies = async (
    variables: UpdateReviewerStrategiesPerformanceReviewProcessMutationVariables
  ) => {
    const response = await updateReviewreviewerStrategies({
      variables: variables,
    })
    const handled = handleResult(response, () => {})
    return { success: handled.success }
  }

  return {
    loading,
    updateReviewerStrategies,
    updateReviewreviewerStrategies,
  }
}
